import { useQuery } from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { getExternalGMSDataForShop } from '../state/actions'

export const ONBOARDING_CACHE_KEY = 'ONBOARDING'
export const WHOLESALER_CACHE_KEY = 'WHOLESALER'

const getShopExternalGMSDataCacheKey = (shopID: string) => ['SHOP_EXTERNAL_GMS_DATA', shopID]

export const useGetShopExternalGMSData = (shopID: string) => {
  const dispatch = useDispatch()

  return useQuery(getShopExternalGMSDataCacheKey(shopID), async () => {
    return (await dispatch(getExternalGMSDataForShop(shopID))).Data
  })
}
